import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetAssignedAdvisorForLead } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';

export const useAssignedAdvisor = (loanRequestId: string, enabled: boolean) =>
    useAggregateQuery({
        acl: { loanRequestId },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getAssignedAdvisorForLead,
        schema: schemaLoanRequestResolver_GetAssignedAdvisorForLead,
        searchParams: { loanRequestId },
        tanstack: { enabled },
    });
